<template src="./template.html"></template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import TENKENGYOUMU_BASE from 'src/consts/tenkengyoumu_base'
import TENKENGYOUMU_DETAIL from 'src/consts/tenkengyoumu_detail'
import DAILY_REPORT from 'src/consts/daily_report'
import MONTHLY_REPORT from 'src/consts/monthly_report'
import masterMixin from 'src/mixins/masterMixin'

export default {
  name: 'tenken-report',
  data() {
    return {
      DAILY_REPORT: DAILY_REPORT,
      MONTHLY_REPORT: MONTHLY_REPORT,

      search: {},

      dailyReportCands: [],
      monthlyReportCands: [],
      origTantoujimushoCands: [],
      tantoujimushoCands: [],
      origRosenCands: [],
      rosenCands: [],
      sekininStaffCands: [],
    }
  },
  computed: {
    ...mapState('user', {
      has_role_admin: state => state.has_role_admin,
    }),
    REPORT() {
      if (!this.search.reportType) { return {} }
      return this[`${this.search.reportType.toUpperCase()}_REPORT`]
    },
    isReportTypeDaily() {
      return this.search.reportType === 'daily'
    },
    isReportTypeMonthly() {
      return this.search.reportType === 'monthly'
    },
    isTenkengyoumuBaseRojou() {
      const reportId = this.search.reportId
      return (parseInt(reportId) === this.REPORT.ROJOU_DOBOKU) ||
        (parseInt(reportId) === this.REPORT.ROJOU_SHISETSU_DENKI)
    },
    isTenkengyoumuBaseRoka() {
      const reportId = this.search.reportId
      return (parseInt(reportId) === this.REPORT.ROKA_DOBOKU) ||
        (parseInt(reportId) === this.REPORT.ROKA_SHISETSU_DENKI)
    },
    isTenkengyoumuBaseKoukashita() {
      const reportId = this.search.reportId
      return parseInt(reportId) === this.REPORT.KOUKASHITA_KOUKASHITA
    },
    isTenkengyoumuDetailDoboku() {
      const reportId = this.search.reportId
      return (parseInt(reportId) === this.REPORT.ROJOU_DOBOKU) ||
        (parseInt(reportId) === this.REPORT.ROKA_DOBOKU)
    },
    isTenkengyoumuDetailShisetsuDenki() {
      const reportId = this.search.reportId
      return (parseInt(reportId) === this.REPORT.ROJOU_SHISETSU_DENKI) ||
        (parseInt(reportId) === this.REPORT.ROKA_SHISETSU_DENKI)
    },
    isTenkengyoumuDetailKoukashita() {
      const reportId = this.search.reportId
      return parseInt(reportId) === this.REPORT.KOUKASHITA_KOUKASHITA
    },
    showRosen() {
      return this.isReportTypeDaily && this.isTenkengyoumuDetailShisetsuDenki
    },
    reportCands() {
      return this[`${this.search.reportType}ReportCands`]
    },
  },
  async mounted() {
    await this.ensureUserAndMasters()
    this.prepareMasters()
    this.prepareSearchParams()
  },
  mixins: [masterMixin],
  methods: {
    getTenkengyoumuBaseId() {
      if (this.isTenkengyoumuBaseRojou) {
        return TENKENGYOUMU_BASE.ROJOU
      } else if (this.isTenkengyoumuBaseRoka) {
        return TENKENGYOUMU_BASE.ROKA
      } else if (this.isTenkengyoumuBaseKoukashita) {
        return TENKENGYOUMU_BASE.KOUKASHITA
      }
    },
    getTenkengyoumuDetailId() {
      if (this.isTenkengyoumuDetailDoboku) {
        return TENKENGYOUMU_DETAIL.DOBOKU
      } else if (this.isTenkengyoumuDetailShisetsuDenki) {
        return TENKENGYOUMU_DETAIL.SHISETSU_DENKI
      } else if (this.isTenkengyoumuDetailKoukashita) {
        return TENKENGYOUMU_DETAIL.KOUKASHITA
      }
    },
    filterByDetailGyoumu(items) {
      const detailGyoumuId = this.getTenkengyoumuDetailId()
      return items.filter(e => {
        return parseInt(e.detail_gyoumu_id) === detailGyoumuId
      })
    },
    filterByDate(items) {
      const dtFrom = new Date(this.search.tenkenDateFrom)
      const dtTo = new Date(this.search.tenkenDateTo)
      return items.filter(e => {
        const startDt = new Date(e.start_date)
        const endDt = new Date(new Date(e.end_date).valueOf() + 86400 * 1000)
        return (startDt <= dtFrom) && (dtTo <= endDt)
      })
    },
    prepareMasters() {
      const master = window.master
      this.dailyReportCands = master.lovs.daily_report.vals
      this.monthlyReportCands = master.lovs.monthly_report.vals
      this.origTantoujimushoCands = master.tantoujimusho.vals
      this.origRosenCands = master.rosen.vals
      this.sekininStaffCands = master.staff.vals.filter(e => e.is_valid && e.is_sekinin)
    },
    prepareSearchParams() {
      const search = {}
      search.reportType = 'daily'
      search.reportId = this.dailyReportCands[0].key
      this.search = search
      this.onReportTypeChange()
    },
    resetTantoujimusho() {
      let tantoujimushoCands = this.origTantoujimushoCands
      tantoujimushoCands = this.filterByDetailGyoumu(tantoujimushoCands)
      tantoujimushoCands = this.filterByDate(tantoujimushoCands)
      this.tantoujimushoCands = tantoujimushoCands

      let tantoujimushoId = null
      if (this.tantoujimushoCands.length > 0) {
        tantoujimushoId = this.tantoujimushoCands[0].m_tantoujimusho_id
      }
      this.search.tantoujimushoId = tantoujimushoId
    },
    resetRosen() {
      this.rosenCands = this.filterByDate(this.origRosenCands)
      this.search.rosenId = null
    },
    resetTenkenSekininsha() {
      let tenkenSekininshaId = null
      if (this.isReportTypeMonthly && this.sekininStaffCands.length > 0) {
        tenkenSekininshaId = this.sekininStaffCands[0].id
      }
      this.search.tenkenSekininshaId = tenkenSekininshaId
    },
    onReportTypeChange() {
      const now = new Date()
      now.setHours(0, 0, 0, 0)
      this.search.createDate = now
      this.onCreateDateChange()
      this.onReportChange()
    },
    onReportChange() {
      this.resetTantoujimusho()
      this.resetRosen()
      this.resetTenkenSekininsha()
    },
    onCreateDateChange() {
      const dt = new Date(this.search.createDate)
      let tenkenDateFrom = dt
      let tenkenDateTo = dt
      if (this.isReportTypeMonthly) {
        tenkenDateFrom = new Date(dt.getFullYear(), dt.getMonth() - 1, 1)
        tenkenDateTo = new Date(dt.getFullYear(), dt.getMonth(), 0)
      }
      this.search.tenkenDateFrom = tenkenDateFrom
      this.search.tenkenDateTo = tenkenDateTo

      this.resetTantoujimusho()
      this.resetRosen()
    },
    onTenkenDateFromChange() {
      const dt = new Date(this.search.tenkenDateFrom)
      let tenkenDateTo
      if (this.isReportTypeDaily) {
        tenkenDateTo = dt
      } else if (this.isReportTypeMonthly) {
        tenkenDateTo = new Date(dt.getFullYear(), dt.getMonth() + 1, 0)
      }
      this.search.tenkenDateTo = tenkenDateTo

      this.resetTantoujimusho()
      this.resetRosen()
    },
    getPrintPagePath() {
      let ret = `/print/${this.search.reportType}-report/`
      if (this.isTenkengyoumuBaseRojou) {
        ret += 'rojou'
      } else if (this.isTenkengyoumuBaseRoka) {
        ret += 'roka'
      } else if (this.isTenkengyoumuBaseKoukashita) {
        ret += 'koukashita'
      }

      const format = this.isReportTypeDaily ? 'yyyy-mm-dd' : 'yyyy-mm'
      ret += `/${Vue.filter('dtFormat')(this.search.tenkenDateFrom, format)}`

      ret += `/${this.getTenkengyoumuDetailId()}`

      let jimushoId = null
      if (this.search.tantoujimushoId) {
        jimushoId = parseInt(this.search.tantoujimushoId)
      } else if (this.search.rosenId) {
        const jimushoIds = window.master.rosenjimusho.vals.filter(e => {
          return parseInt(e.rosen_id) === parseInt(this.search.rosenId)
        }).map(e => {
          return parseInt(e.jimusho_id)
        })
        const tantoujimusho = window.master.tantoujimusho.vals.filter(e => {
          return parseInt(e.detail_gyoumu_id) === this.getTenkengyoumuDetailId()
        }).find(e => {
          const tantoujimushoId = parseInt(e.m_tantoujimusho_id)
          return jimushoIds.findIndex(id => id === tantoujimushoId) !== -1
        })
        jimushoId = parseInt(tantoujimusho.m_tantoujimusho_id)
      }
      ret += `/${jimushoId}`

      return ret
    },
    async goToPrintPage() {
      const path = this.getPrintPagePath()
      let query = {}

      if (this.isReportTypeDaily) {
        if (this.search.rosenId) {
          query.rosen_id = parseInt(this.search.rosenId)
        }
      } else if (this.isReportTypeMonthly) {
        query = {
          create_date: Vue.filter('dtFormat')(this.search.createDate, 'yyyy-mm-dd'),
          tenken_sekininsha_id: parseInt(this.search.tenkenSekininshaId),
        }
      }
      const router = this.$router.resolve({
        path: path,
        query: query,
      })
      window.open(router.href, '_blank')
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
